import React from 'react';
import HeroSection from './HeroSection.jsx';
import FeaturedProducts from './FeaturedProducts.jsx';
import Services from './Services.jsx';
import Categories from './Categories.jsx';
import Contact from './ContactUsPage.jsx';

const HomePage = ({ addToCart, addToFavorites, favorites, setCurrentPage }) => {
  return (
    <div>
      <HeroSection setCurrentPage={setCurrentPage} />
      <FeaturedProducts addToCart={addToCart} addToFavorites={addToFavorites} favorites={favorites} />
      <Categories setCurrentPage={setCurrentPage} />
      <Contact />
      <Services setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default HomePage;
